export default __webpack_public_path__ + "static/media/CORE_christmas_club.ba1a7e40.png";